// src/components/shopping/ChangeProductModal.js
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import OfferCard from "./OfferCard";

export default function ChangeProductModal({
    open,
    onClose,
    offers,
    quantity,
    unit,
    lang = "gr",
    bestOfferProductVariantId,
    onSelectOffer,
    productName,
}) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>
                {lang === "gr" || lang === "el"
                    ? `Επιλογή προϊόντος για ${productName || ""}`
                    : `Select product for ${productName || ""}`}
            </DialogTitle>

            <DialogContent dividers>
                {(!offers || offers.length === 0) && (
                    <Typography variant="body2" color="text.secondary">
                        {lang === "gr" || lang === "el"
                            ? "Δεν βρέθηκαν προϊόντα για αυτή την τοποθεσία."
                            : "No products found for this location."}
                    </Typography>
                )}

                {offers &&
                    offers.map((offerRaw) => {
                        const normalizedProductVariantId =
                            offerRaw.product_variant_id ?? offerRaw.id ?? null;
                        // 🔹 ΕΤΟΙΜΟ κείμενο συσκευασίας (αν δεν υπάρχει)
                        const package_label =
                            offerRaw.package_label ||
                            offerRaw.package_size_text ||
                            (offerRaw.normalized_qty && offerRaw.normalized_unit
                                ? `${offerRaw.normalized_qty} ${offerRaw.normalized_unit}`
                                : null);

                        // 🔹 Τιμή ΜΟΝΑΔΑΣ (€/kg ή €/L) – δεν ξαναυπολογίζουμε εδώ
                        const unit_price =
                            offerRaw.unit_price ??
                            offerRaw.unit_price_per_kg ??
                            offerRaw.price_per_piece ??
                            offerRaw.price_per_kg ??
                            offerRaw.price_per_liter ??
                            null;
                        const unit_kind =
                            offerRaw.unit_kind ||
                            offerRaw.unit_price_kind ||
                            (offerRaw.price_per_piece != null
                                ? "piece"
                                : offerRaw.price_per_liter != null
                                    ? "l"
                                    : offerRaw.price_per_kg != null
                                        ? "kg"
                                        : null);

                        // 🔹 Τιμή ΣΥΣΚΕΥΑΣΙΑΣ (package_price)
                        const package_price =
                            offerRaw.package_price ??
                            offerRaw.variant_price ??
                            offerRaw.price ??
                            null;

                        const offer = {
                            ...offerRaw,
                            product_variant_id: normalizedProductVariantId,
                            package_label,
                            unit_price,
                            unit_kind,
                            package_price,
                        };

                        return (
                            <OfferCard
                                key={
                                    offer.product_variant_id ||
                                    offer.external_id ||
                                    offer.product_id
                                }
                                offer={offer}
                                quantity={quantity}
                                unit={unit}
                                lang={lang}
                                isBest={
                                    offer.product_variant_id ===
                                    bestOfferProductVariantId
                                }
                                onSelect={() => onSelectOffer(offer)}
                            />
                        );
                    })}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    {lang === "gr" || lang === "el" ? "Κλείσιμο" : "Close"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
